import { create } from 'zustand'
import { devtools } from 'zustand/middleware'
import { CreatePolicyholderEntityClientResponse } from '../@types/CreatePolicyholderEntity'

type Store = {
  isPolicyholderCreated: boolean
  setIsPolicyholderCreated: (value: boolean) => void
  createPolicyHolderEntity: CreatePolicyholderEntityClientResponse | null
  setCreatePolicyHolderEntity: (
    value: CreatePolicyholderEntityClientResponse,
  ) => void
}

export const useCreatePolicyHolderEntityStore = create<Store>()(
  devtools(
    (set) => ({
      isPolicyholderCreated: false,
      setIsPolicyholderCreated: (isPolicyholderCreated) =>
        set({ isPolicyholderCreated }),
      createPolicyHolderEntity: null,
      setCreatePolicyHolderEntity: (createPolicyHolderEntity) =>
        set({ createPolicyHolderEntity }),
    }),
    { name: 'createPolicyHolderEntityStore' },
  ),
)
